module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('número da nota')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "número da nota"
    }
  }, [_vm._v("Número nota fiscal:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 "
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "número da nota",
      "type": "text",
      "mask": ['#########'],
      "min": "1"
    },
    model: {
      value: (_vm.nota.numero),
      callback: function($$v) {
        _vm.$set(_vm.nota, "numero", $$v)
      },
      expression: "nota.numero"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('número da nota')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('número da nota')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('data de emissão')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "data de emissão"
    }
  }, [_vm._v("Data de emissão do documento:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "data de emissao",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.nota.emissao),
      callback: function($$v) {
        _vm.$set(_vm.nota, "emissao", $$v)
      },
      expression: "nota.emissao"
    }
  })], 1)]), _vm._v(" "), (_vm.errors.first('data de emissão')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data de emissão')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('série')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "série"
    }
  }, [_vm._v("Série:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.serie),
      expression: "nota.serie"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "série"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.nota, "serie", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "NOTA_FISCAL"
    }
  }, [_vm._v("1 - Nota fiscal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RECIBO_PAGAMENTO_AUTONOMO"
    }
  }, [_vm._v("10 - Recibo de pagamento a autônomo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DOCUMENTO_NAO_FISCAL"
    }
  }, [_vm._v("DNF - Documento não fiscal")])])]), _vm._v(" "), (_vm.errors.first('série')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('série')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "data de validade"
    }
  }, [_vm._v("Data de validade do documento: (Somente informe se possuir a data)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    attrs: {
      "name": "data de validade",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "clear-button": true,
      "clear-button-icon": "fa fa-times-circle-o",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.nota.validade),
      callback: function($$v) {
        _vm.$set(_vm.nota, "validade", $$v)
      },
      expression: "nota.validade"
    }
  })], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documento fiscal")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50211d4e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/modulos/documentoFiscal.vue
// module id = 1893
// module chunks = 2